import { useId } from "react";

/** Pinceladas amarelas de fundo, como um rastro de velocidade (traço "sujo" via feTurbulence). */
export const BrushStrokes = ({ className }: { className?: string }) => {
  const filterId = `brush-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;

  return (
    <svg viewBox="0 0 600 500" fill="none" aria-hidden="true" className={className}>
      <defs>
        <filter id={filterId} x="-10%" y="-30%" width="120%" height="160%">
          <feTurbulence type="fractalNoise" baseFrequency="0.035 0.9" numOctaves="2" seed="4" />
          <feDisplacementMap in="SourceGraphic" scale="22" />
        </filter>
      </defs>
      <g filter={`url(#${filterId})`} stroke="#FFC107" strokeLinecap="round">
        <path data-brush d="M30 322C130 282 250 262 370 262" strokeWidth="96" />
        <path data-brush d="M60 156C160 116 270 102 390 110" strokeWidth="44" opacity="0.9" />
        <path data-brush d="M120 438C220 418 330 414 430 422" strokeWidth="20" opacity="0.6" />
      </g>
    </svg>
  );
};
